import { adminHttpClient } from '../../../../commons/adminHttpClient'

export type IchraClassType = {
  id: number
  name: string
  isCustom: boolean
  relationId?: string
}
export const getIchraClassTypes = (): Promise<IchraClassType[]> => {
  return adminHttpClient.get(`/AdminDashboard/ichra/classTypes`)
}
